import { isTwoD } from './isTwoD';
/**
 * Apply a general filtering to a nmriumState data
 */
export function generalFiltering(datum, filter = {}) {
    const { data, ...rest } = datum;
    if (!data)
        return datum;
    const { spectra: spectraOld = [] } = data;
    const { keep1D = true, keep2D = true, onlyReal } = filter;
    const dataSelection = onlyReal ? 'ft' : filter.dataSelection || 'both';
    const spectra = [];
    for (const spectrum of spectraOld) {
        if (!spectrum.info) {
            spectra.push(spectrum);
            continue;
        }
        const { isFid, dimension } = spectrum.info;
        if (dimension === 1 && !keep1D)
            continue;
        if (dimension === 2 && !keep2D)
            continue;
        if (isFid && dataSelection === 'ft')
            continue;
        if (!isFid && dataSelection === 'fid')
            continue;
        if (onlyReal && !isFid) {
            spectrum.info.isComplex = false;
            if (isTwoD(spectrum)) {
                const { rr } = spectrum.data;
                spectra.push({ ...spectrum, data: { rr } });
            }
            else {
                const { re, x } = spectrum.data;
                spectra.push({ ...spectrum, data: { re, x } });
            }
        }
        else {
            spectra.push(spectrum);
        }
    }
    return {
        data: { ...data, spectra },
        ...rest,
    };
}
//# sourceMappingURL=generalFiltering.js.map